// extracted by mini-css-extract-plugin
module.exports = {"RelatedEntities__Container":"_6vrlp","RelatedEntities":"PULDR","RelatedEntities__Card":"QOAyj"};